"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.states = void 0;
// State names used in the AppointmentWaitlist machines
exports.states = {
    fetchingWaitlist: '@state/FETCHING_WAITLIST',
    success: '@state/SUCCESS',
    error: '@state/ERROR',
    // Loading machine states
    routing: '@state/ROUTING',
    fetchWaitlist: '@state/FETCH_WAITLIST',
    fetchProvider: '@state/FETCH_PROVIDER',
    done: '@state/DONE',
    loadingDone: '@state/LOADING_DONE',
    // ConfimrDob Machine states
    confirmDob: '@state/CONFIRM_DOB',
    idle: '@state/IDLE',
    validating: '@state/VALIDATING',
    validateSuccess: '@state/VALIDATE_SUCCESS',
    validateFailure: '@state/VALIDATE_FAILURE',
    apptTime: '@state/APPT_TIME'
};
exports.default = exports.states;
//# sourceMappingURL=States.js.map